import { drybulkCargoOperationsService, type PartyType } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

/** DBCO-0029 (R-07) - the side panel of a Shipper or S.Pile code; read when the panel opens. */
export const useParty = (
  operationId: string,
  code: string | null,
  type: PartyType | null,
  enabled: boolean,
) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.party(operationId, type ?? "", code ?? ""),
    queryFn: () => drybulkCargoOperationsService.getParty(operationId, code!, type!),
    enabled: enabled && Boolean(code && type),
    refetchOnWindowFocus: false,
    retry: false,
  });
